import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsHomeAutomationTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.home-automation')} />
      <IntegrationsTable category={IntegrationCategory.HOME_AUTOMATION} />
    </section>
  );
};

export default IntegrationsHomeAutomationTab;
